import React from 'react';
import './GlobalTestCentres.css';

const GlobalTestCentres = () => {
    return (
        <div className="test-centres-container">
            <h2 className="test-centres-heading">Global Test Centers</h2>
            <p className="test-centres-description">
                The IMAT exam is conducted globally, offering aspiring medical students the convenience of taking the test closer to home. Here are some key locations where the IMAT is held:
            </p>
            <div className="test-centres-list">
                 {/* Right List - International */}
                 <ul className="right-list">
                    <li><strong>International:</strong></li>
                    <li>Albania – Tirana</li>
                    <li>Azerbaijan – Baku</li>
                    <li>Brazil – São Paulo</li>
                    <li>Canada – Toronto</li>
                    <li>China – Beijing</li>
                    <li>Cyprus – Nicosia</li>
                    <li>France – Paris</li>
                    <li>Germany – Frankfurt</li>
                    <li>Germany – Munich</li>
                    <li>Greece – Athens</li>
                    <li>Hong Kong</li>
                    <li>India – New Delhi</li>
                    <li>Ireland</li>
                    <li>Pakistan</li>
                    <li>Poland</li>
                    <li>Portugal</li>
                    <li>Saudi Arabia</li>
                    <li>South Africa</li>
                    <li>Spain</li>
                    <li>Switzerland</li>
                    <li>Turkey</li>
                    <li>United Arab Emirates – Dubai</li>
                    <li>United Kingdom</li>
                    <li>United States – New York</li>
                </ul>
                
                {/* Left List - Italy */}
                <ul className="left-list">
                    <li><strong>Italy:</strong></li>
                    <li>Bari – Università degli Studi di Bari</li>
                    <li>Milan – Università degli Studi di Milano</li>
                    <li>Milan – Università degli Studi di Milano Bicocca</li>
                    <li>Pavia – Università degli Studi di Pavia</li>
                    <li>Rome – Università degli Studi di Roma “La Sapienza”</li>
                    <li>Rome – Università degli Studi di Roma “Tor Vergata”</li>
                    <li>Naples – Università degli Studi della Campania “Luigi Vanvitelli”</li>
                    <li>Naples – Università degli Studi di Napoli Federico II</li>
                    <li>Messina – Università degli Studi di Messina</li>
                    <li>Bologna – Università di Bologna</li>
                    <li>Turin – Università degli Studi di Torino</li>
                    <li>Padua – Università degli Studi di Padova</li>
                    <li>Parma – Università degli Studi di Parma</li>
                    <li>Siena – Università degli Studi di Siena</li>
                    <li>Ancona – Università Politecnica delle Marche</li>
                    <li>Catania – Università degli Studi di Catania</li>
                    <li>Cagliari – Università degli Studi di Cagliari</li>
                </ul>

               
            </div>
        </div>
    );
};

export default GlobalTestCentres;